"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _Constants = require("./Constants");

var QuestionEntityRecordBase = (0, _immutable.Record)({
  questionId: null,
  playbookId: null,
  version: null,
  question: '',
  note: '',
  answerType: null,
  includeNotes: true,
  quickAnswers: (0, _immutable.OrderedSet)(),
  objectType: null,
  propertyName: null,
  propertyFieldType: null,
  propertyType: null,
  propertyValueTextMap: (0, _immutable.Map)(),
  propertyNumberDisplayHint: null,
  propertyShowCurrencySymbol: false,
  currencyCode: null,
  enableMultiSelect: true,
  selected: (0, _immutable.OrderedSet)(),
  state: 'DRAFT'
}, 'QuestionEntityRecord');

var QuestionEntityRecord =
/*#__PURE__*/
function (_QuestionEntityRecord) {
  (0, _inherits2.default)(QuestionEntityRecord, _QuestionEntityRecord);

  function QuestionEntityRecord() {
    (0, _classCallCheck2.default)(this, QuestionEntityRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(QuestionEntityRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(QuestionEntityRecord, [{
    key: "isNoteOnly",
    value: function isNoteOnly() {
      return this.answerType === _Constants.AnswerTypes.TEXT_ONLY;
    }
  }, {
    key: "isFreeformQuickReply",
    value: function isFreeformQuickReply() {
      return this.answerType === _Constants.AnswerTypes.QUICK_REPLIES;
    }
  }, {
    key: "isPropertyQuickReply",
    value: function isPropertyQuickReply() {
      return this.answerType === _Constants.AnswerTypes.PROPERTY_QUICK_REPLIES;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      if (!this.answerType) {
        return false;
      }

      if (this.isFreeformQuickReply()) {
        return !this.quickAnswers.isEmpty();
      }

      if (this.isPropertyQuickReply()) {
        return !!(this.objectType && this.propertyName);
      }

      return true;
    }
  }, {
    key: "setQuestionText",
    value: function setQuestionText(question) {
      return this.set('question', question);
    }
  }, {
    key: "setAnswerType",
    value: function setAnswerType(answerType) {
      return this.merge({
        answerType: answerType,
        quickAnswers: (0, _immutable.OrderedSet)(),
        objectType: null,
        propertyName: null,
        enableMultiSelect: true
      });
    }
  }, {
    key: "setFreeformAnswers",
    value: function setFreeformAnswers(quickReplies) {
      return this.merge({
        quickAnswers: (0, _immutable.OrderedSet)(quickReplies)
      });
    }
  }, {
    key: "setObjectType",
    value: function setObjectType(objectType) {
      if (objectType === this.objectType) {
        return this;
      }

      return this.merge({
        objectType: objectType,
        propertyName: null
      });
    }
  }, {
    key: "setProperty",
    value: function setProperty(property) {
      if (!property) {
        return this.merge({
          propertyName: null,
          enableMultiSelect: true
        });
      }

      var propertyValueTextMap = (0, _immutable.Map)();

      if (property.get('options')) {
        propertyValueTextMap = property.get('options').reduce(function (valueTextMap, option) {
          return valueTextMap.set(option.get('value'), option.get('label'));
        }, (0, _immutable.Map)());
      }

      return this.merge({
        propertyName: property.get('name'),
        propertyFieldType: property.get('fieldType'),
        propertyType: property.get('type', null),
        propertyNumberDisplayHint: property.get('numberDisplayHint', null),
        propertyShowCurrencySymbol: property.get('showCurrencySymbol', false),
        propertyValueTextMap: propertyValueTextMap,
        // TODO: Remove enableMultiSelect and rely only on checking the fieldType
        enableMultiSelect: property.get('fieldType') === 'checkbox'
      });
    }
  }, {
    key: "isNumber",
    value: function isNumber() {
      return this.propertyFieldType === 'number';
    }
  }, {
    key: "isFormattedNumber",
    value: function isFormattedNumber() {
      return this.isNumber() && this.propertyNumberDisplayHint === 'formatted';
    }
  }, {
    key: "isCurrency",
    value: function isCurrency() {
      return this.isFormattedNumber() && this.propertyShowCurrencySymbol;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      switch (this.propertyFieldType) {
        case 'number':
        case 'textarea':
        case 'text':
          return this.set('selected', (0, _immutable.OrderedSet)([value]));

        case 'checkbox':
        case 'booleancheckbox':
        case 'radio':
        case 'select':
        default:
          return this.selectOption(value);
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      switch (this.propertyFieldType) {
        case 'number':
          {
            var value = Number(this.selected.first());
            return isNaN(value) ? null : value;
          }

        case 'textarea':
        case 'text':
          return this.selected.first() || null;

        case 'booleancheckbox':
        case 'checkbox':
        case 'radio':
        case 'select':
        default:
          return this.selected;
      }
    }
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      var _this = this;

      switch (this.propertyFieldType) {
        case 'number':
          {
            var value = Number(this.selected.first());

            if (isNaN(value)) {
              return null;
            }

            if (this.isCurrency()) {
              return _I18n.default.formatCurrency(value, {
                currencyCode: this.currencyCode
              });
            }

            if (this.isFormattedNumber()) {
              return _I18n.default.formatNumber(value);
            }

            return "" + value;
          }

        case 'booleancheckbox':
        case 'radio':
        case 'select':
        case 'textarea':
        case 'text':
          {
            var _value = this.selected.first() || '';

            var labelForValue = this.propertyValueTextMap.get(_value, _value);
            return "" + labelForValue;
          }

        case 'checkbox':
        default:
          {
            var labelsForSelected = this.selected.map(function (value) {
              return _this.propertyValueTextMap.get(value, value);
            });
            return "" + labelsForSelected.join(', ');
          }
      }
    }
  }, {
    key: "getValueForObjectProperty",
    value: function getValueForObjectProperty() {
      switch (this.propertyFieldType) {
        case 'checkbox':
          return this.getOptionsString();

        case 'booleancheckbox':
        case 'radio':
        case 'select':
        case 'number':
        default:
          return this.selected.first() || null;
      }
    }
  }, {
    key: "selectOption",
    value: function selectOption(option) {
      if (this.selected.includes(option)) {
        return this.update('selected', function (selected) {
          return selected.remove(option);
        });
      } // TODO: Just check if the field is a checkbox once the legacy plugin is gone


      if (!this.enableMultiSelect) {
        return this.set('selected', (0, _immutable.OrderedSet)([option]));
      }

      return this.update('selected', function (selected) {
        return selected.add(option);
      });
    }
  }, {
    key: "getOptionsString",
    value: function getOptionsString() {
      var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
      return this.selected.join(separator);
    }
  }], [{
    key: "fromApi",
    value: function fromApi(data) {
      var id = data.id,
          selected = data.selected,
          quickAnswers = data.quickAnswers,
          _data$note = data.note,
          note = _data$note === void 0 ? '' : _data$note;
      return new QuestionEntityRecord((0, _extends2.default)({}, data, {
        questionId: id,
        selected: (0, _immutable.OrderedSet)(selected),
        quickAnswers: (0, _immutable.OrderedSet)(quickAnswers),
        note: note || ''
      }));
    }
  }]);
  return QuestionEntityRecord;
}(QuestionEntityRecordBase);

exports.default = QuestionEntityRecord;
module.exports = exports.default;